//
//
//
//
//
//

import api from '@/api'
export default {
  data: () => ({
    number: 0
  }),
  methods: {
    initData () {
      this.axios.get(api.user.notifyNum)
      .then(response => {
        if (response.data.data) {
          console.log()
          this.number = response.data.data.comment_num + response.data.data.credit_num + response.data.data.notify_num
        }
      })
    }
  },
  created () {
    this.initData()
  }
}



// WEBPACK FOOTER //
// ./src/views/feed/new-message.vue